// Configuraciones
const ADMIN_PRIVATE_WRAPPER = 'private';

export const FEATURE_STORE_KEY = 'cartera';

export const MODULE_PATHS_CONSTANTS = {
  BASE_ROUTE: 'cartera',
  // Cupos
  LISTADO_CARTERA: 'carteras',
  LISTADO_DEUDORES: 'deudores',
  DETALLE_CARTERA: 'carteras/:id',
  LISTADO_PAGOS_FALLIDOS: 'pagos-fallidos',
  LISTADO_ENDOSOS: 'endosos',
};

export const generateFullModuleRoute = (route: string): string => {
  return `${MODULE_PATHS_CONSTANTS.BASE_ROUTE}/${route}`;
};

export const fullAppPageRoute = (route: string): string => {
  return `${ADMIN_PRIVATE_WRAPPER}/${generateFullModuleRoute(route)}`;
};

export const MODULE_NAVIGATION_MENU = [
  {
    title: 'Cartera',
    collapsed: true,
    collapsable: true,
    activated: true,
    navigationItems: [
      {
        icon: 'pi pi-list',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.LISTADO_CARTERA),
        title: 'Cartera',
        activated: true,
      },
      {
        icon: 'pi pi-dollar',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.LISTADO_DEUDORES),
        title: 'Saldos',
        activated: true,
      },
      {
        icon: 'pi pi-exclamation-triangle',
        route: generateFullModuleRoute(
          MODULE_PATHS_CONSTANTS.LISTADO_PAGOS_FALLIDOS
        ),
        title: 'Pagos fallidos',
        activated: true,
      },
      {
        icon: 'pi pi-file-edit',
        route: generateFullModuleRoute(MODULE_PATHS_CONSTANTS.LISTADO_ENDOSOS),
        title: 'Endosos',
        activated: true,
      },
    ],
  },
];

export const MODULE_ROUTES_NOT_MENU = [];

export const ESTADO_CUOTA_DEUDORES = {
  PAGO: 'C',
  PENDIENTE: 'O',
};

export enum DocumentFileName {
  CONDICIONES = 'Condiciones',
  CUPONES = 'Cupones',
  POLIZA = 'Poliza',
}

export const CONFIG_LISTADO = {
  DEBT_LIST: 'admin.debt.debt-list',
};

export const LIST_PORTFOLIO_COLUMNS_NAME = {
  DAYS_SINCE: 'daysSince',
  CARD_NAME: 'cardName',
  DOCUMENT: 'document',
  POLICY: 'policy',
  AGENT_CODE: 'agentCode',
  BROKER: 'broker',
  PRODUCT: 'product',
  INVOICE_NUMBER: 'invoiceNumber',
  ISSUANCE: 'issuance',
  EFFECTIVE_DATE: 'effectiveDate',
  EXPIRATION_DATE: 'expirationDate',
  CURRENCY: 'currency',
  TOTAL_OVERDUE: 'totalOverdue',
  TOTAL_DUE: 'totalDue',
  TOTAL_DEBT: 'totalDebt',
  PAID_INSTALLMENTS: 'paidInstallments',
  NEXT_EXPIRATION_DATE: 'nextExpirationDate',
  NEXT_AMOUNT_DUE: 'nextAmountToExpire',
  ACTIONS: 'actions',
};

export const LIST_PORTFOLIO_COLUMNS_TITLE = {
  DAYS_SINCE: 'Estado',
  CARD_NAME: 'Asegurado',
  DOCUMENT: 'Documento',
  POLICY: 'Póliza',
  AGENT_CODE: 'Responsable',
  BROKER: ' Corredor',
  PRODUCT: 'Producto',
  INVOICE_NUMBER: 'Nro. de factura',
  ISSUANCE: 'Emisión',
  EFFECTIVE_DATE: 'Inicio de vigencia',
  EXPIRATION_DATE: 'Fin de vigencia',
  CURRENCY: 'Moneda',
  TOTAL_OVERDUE: 'Total vencido',
  TOTAL_DUE: 'Total a vencer',
  TOTAL_DEBT: 'Total deuda',
  PAID_INSTALLMENTS: 'Cuotas pagas',
  NEXT_EXPIRATION_DATE: 'Próximo vencimiento',
  NEXT_AMOUNT_DUE: 'Próximo importe a vencer',
  ACTIONS: 'Acción',
};

export const LIST_DEBT_COLUMNS_NAME = {
  PRODUCT: 'product',
  CARD_NAME: 'cardName',
  DOCUMENT: 'document',
  POLICY: 'policy',
  BROKER: 'broker',
  BROKER_BL: 'brokerBL',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  PRIZE: 'prize',
  PAYMENT_METHOD: 'paymentMethod',
  ACTIONS: 'actions',
};

export const LIST_DEBT_COLUMNS_TITLE = {
  PRODUCT: 'Producto',
  CARD_NAME: 'Asegurado',
  DOCUMENT: 'Documento',
  POLICY: 'Póliza',
  BROKER: ' Corredor',
  BROKER_BL: 'BL del Corredor',
  START_DATE: 'Inicio de vigencia',
  END_DATE: 'Fin de vigencia',
  PRIZE: 'Premio',
  PAYMENT_METHOD: 'Medio de pago',
  ACTIONS: 'Acción',
};

export const CURRENCY_OPTIONS = [
  { name: 'USD', value: 'USD' },
  { name: 'UYU', value: 'UYU' },
  { name: 'EUR', value: 'EUR' },
];

export const AGENT_CODES = {
  SUBSCRIPTION_ACTIVE: '011',
};

export const PROCESS_STATUS = {
  PENDIENTE_CANCELACION: 2,
  PENDIENTE_DEBITO: 1,
  DEFAULT: 0,
};

export const TOOTLTIP_TEXT = {
  DEBIT_PENDING: 'El cambio a débito automático está en proceso.',
  CANCEL_PENDING: 'La cancelación a débito automático está en proceso.',
};

export const CONFIG_LIST_PROCESSED_ENDORSEMENT =
  'admin.debt.processed-endorsement-list';

export const LIST_PROCESSED_ENDORSEMENT_COLUMNS_NAME = {
  PRODUCT: 'product',
  ISSUED_DATE: 'issueDate',
  ENDORSEMENT_NUMBER: 'endorsementNumber',
  ENDORSEMENT_TYPE: 'endorsementType',
  POLICY_NUMBER: 'policyNumber',
  ASSURED: 'assuredName',
};

export const LIST_PROCESSED_ENDORSEMENT_COLUMNS_TITLE = {
  PRODUCT: 'Producto',
  ISSUED_DATE: 'Fecha de emisión',
  ENDORSEMENT_NUMBER: 'Nro. de endoso',
  ENDORSEMENT_TYPE: 'Tipo de endoso',
  POLICY_NUMBER: 'Póliza',
  ASSURED: 'Asegurado',
};

export enum ORDER_LIST_PROCESSED_ENDORSEMENT {
  product_a = 'Product:a',
  product_d = 'Product:d',
  policyNumber_a = 'PolicyNumber:a',
  policyNumber_d = 'PolicyNumber:d',
  assuredName_a = 'AssuredName:a',
  assuredName_d = 'AssuredName:d',
  issueDate_a = 'IssueDate:a',
  issueDate_d = 'IssueDate:d',
  endorsementType_a = 'EndorsementType:a',
  endorsementType_d = 'EndorsementType:d',
}

export const CONFIG_LIST_FAILED_ENDORSEMENT =
  'admin.debt.failed-endorsement-list';

export const LIST_FAILED_ENDORSEMENT_COLUMNS_NAME = {
  PRODUCT: 'product',
  ENDORSEMENT_NUMBER: 'endorsementNumber',
  ENDORSEMENT_TYPE: 'endorsementType',
  POLICY_NUMBER: 'policyNumber',
  ASSURED: 'assuredName',
  ISSUED_DATE: 'issueDate',
  ERROR: 'error',
};

export const LIST_FAILED_ENDORSEMENT_COLUMNS_TITLE = {
  PRODUCT: 'Producto',
  ENDORSEMENT_NUMBER: 'Nro. de endoso',
  ENDORSEMENT_TYPE: 'Tipo de endoso',
  POLICY_NUMBER: 'Póliza',
  ASSURED: 'Asegurado',
  ISSUED_DATE: 'Fecha de emisión',
  ERROR: 'Error',
};

export enum ORDER_LIST_FAILED_ENDORSEMENT {
  product_a = 'Product:a',
  product_d = 'Product:d',
  assuredName_a = 'AssuredName:a',
  assuredName_d = 'AssuredName:d',
  policyNumber_a = 'PolicyNumber:a',
  policyNumber_d = 'PolicyNumber:d',
  endorsementType_a = 'EndorsementType:a',
  endorsementType_d = 'EndorsementType:d',
}

export const PRODUCT_OPTIONS = [
  // Se ocultan momentaneamente hasta que se implemente la creación de endoso para estos módulos
  // { name: 'Garantía', value: 'Garantía' },
  // { name: 'Transporte', value: 'Transporte' },
  { name: 'Multiseguros', value: 'Multiseguros' },
  { name: 'Automóviles', value: 'Automóviles' },
];

export const ENDORSEMENT_TYPE_OPTIONS = [
  { name: 'Cambio de matrícula', value: 'Cambio de matrícula' },
  { name: 'Cesión de derechos', value: 'Cesión de derechos' },
  { name: 'Anular cesión de derechos', value: 'Anular cesión de derechos' },
  { name: 'Cancelación', value: 'Cancelación' },
];
